export default {
  登录已过期: '登錄已過期',
  查询地址户信息: '查詢地址戶信息',
  获取地址户信息失败: '獲取地址戶信息失敗',
  保存收货地址失败: '保存收貨地址失敗',
  收货地址: '收貨地址',
  名字: '名字',
  请输入名字: '請輸入名字',
  手机号: '手機號',
  请输入手机号: '請輸入手機號',
  请输入邮箱: '請輸入郵箱',
  地址: '地址',
  请选择地区: '請選擇地區',
  请输入详细地址: '請輸入詳細地址',
  保存: '保存',
  今天: '今天',
  本月: '本月',
  本季: '本季',
  本年: '本年',
  自定义时间: '自定義時間',
  至: '至',
  取消: '取消',
  确认: '確認',
  总库存小于起订量: '總庫存小於起訂量',
  选规格: '選規格',
  自提: '自提',
  不能输入小数: '不能輸入小數',
  '最多可填{{qualityPrecision}}位小数': '最多可填{{qualityPrecision}}位小數',
  批量加购: '批量加購',
  填写数量: '填寫數量',
  确定: '確定',
  以下规格库存不足: '以下規格庫存不足',
  已自动修改数量: '已自動修改數量',
  '库存不足，已修改下单数量': '庫存不足，已修改下單數量',
  '加载中…': '載入中…',
  删除成功: '刪除成功',
  库存: '庫存',
  购买数量: '購買數量',
  添加备注: '添加備註',
  最低起订量: '最低起訂量',
  '，还差': '，還差',
  '总 数': '總數',
  总金额: '總金額',
  移出购物车: '移出購物車',
  请输入内容: '請輸入內容',
  输入内容: '輸入內容',
  海外发货: '海外發貨',
  国内发货: '國內發貨',
  销量: '銷量',
  单: '單',
  个: '個',
  上次价: '上次價',
  暂无货品: '暫無貨品',
  '--- 已经到底啦 ---': '--- 已經到底啦---',
  搜索: '搜尋',
  综合: '綜合',
  价格: '價格',
  销售单数: '銷售單數',
  最新上架时间: '最新上架時間',
  货名: '貨名',
  按: '按',
  排序: '排序',
  '按{{name}}排序': '按{{name}}排序',
  库存小于起订量: '庫存小於起訂量',
  '起订量为{{minNumStep}}{{unitName}}': '起訂量為{{minNumStep}}{{unitName}}',
  当前数量加上起订量后大于库存: '當前數量加上起訂量後大於庫存',
  '最低起订量为{{minNumStep}}{{unitName}}':
    '最低起訂量為{{minNumStep}}{{unitName}}',
  '最大库存为{{stock}}{{unitName}}': '最大庫存為{{stock}}{{unitName}}',
  首页: '首頁',
  全部货品: '全部貨品',
  购物车: '購物車',
  我的: '我的',
  已下架: '已下架',
  库存不足: '庫存不足',
  已删除: '已刪除',
  全部: '全部',
  买过: '買過',
  推荐: '推薦',
  新品: '新品',
  爆品: '爆品',
  促销: '促銷',
  请求已过期: '請求已過期',
  进入店铺: '進入店鋪',
  企业图片: '企業圖片',
  企业介绍: '企業介紹',
  请求数据: '請求數據',
  加载下一页: '加載下一頁',
  '请求中loading...': '請求中loading...',
  '请求出错了, {{msg}}': '請求出錯了, {{msg}}',
  列表数据为空: '列表數據為空',
  注册: '註冊',
  登录: '登入',
  重置密码: '重置密碼',
  获取验证码: '獲取驗證碼',
  重新发送: '重新發送',
  '请输入新密码（4-16位）': '請輸入新密碼（4-16位）',
  '请输入密码（4-16位）': '請輸入密碼（4-16位）',
  请输入密码: '請輸入密碼',
  请输入手机: '請輸入手機',
  请输入手机或邮箱: '請輸入手機或郵箱',
  请再次输入密码: '請再次輸入密碼',
  中文: '中文',
  越南语: '越南語',
  英文: '英文',
  手机号为18位以内的数字: '手機號為18位以內的數字',
  请输入正确的手机号: '請輸入正確的手機號碼',
  请输入正确的邮箱号: '請輸入正確的郵箱號碼',
  请输入密码和确认密码: '請輸入密碼和確認密碼',
  '密码为4~16位字符': '密碼為4~16位字符',
  两次输入的密码不一致: '兩次輸入的密碼不一致',
  请输入邀请码: '請輸入邀請碼',
  '请先阅读并勾选《用户协议》和《隐私政策》':
    '請先閱讀並勾選《用戶協議》和《隱私政策》',
  请输入验证码: '請輸入驗證碼',
  '密码修改成功 请用新密码登录': '密碼修改成功請用新密碼登錄',
  用已有账号登录: '用已有賬號登錄',
  新用户注册: '新用戶註冊',
  忘记密码: '忘記密碼',
  请填写邀请码: '請填寫邀請碼',
  已阅读并同意: '已閱讀並同意',
  用户协议: '用戶協議',
  和: '和',
  隐私政策: '隱私政策',
  退出登录: '退出登錄',
  获取用户信息失败: '獲取用戶信息失敗',
  我的资料: '我的資料',
  点击登录: '點擊登錄',
  我的订单: '我的訂單',
  待确认: '待確認',
  待发货: '待發貨',
  '待收货/自提': '待收貨/自提',
  已完成: '已完成',
  '退款/售后': '退款/售後',
  上传中: '上傳中',
  上传头像失败: '上傳頭像失敗',
  上传成功: '上傳成功',
  更新用户信息失败: '更新用戶信息失敗',
  更换头像: '更換頭像',
  头像: '頭像',
  姓名: '姓名',
  公司: '公司',
  手机: '手機',
  邮箱: '郵箱',
  我的地址: '我的地址',
  待付款: '待付款',
  配送中: '配送中',
  已发货: '已發貨',
  已取消: '已取消',
  '总额:': '總額:',
  '总量:': '總量:',
  已作废订单不汇总统计: '已作廢訂單不匯總統計',
  物流选项: '物流選項',
  '地址:': '地址:',
  运输费: '運輸費',
  COD服务费: 'COD服務費',
  待自提: '待自提',
  待配送: '待配送',
  已作废: '已作廢',
  头程已发货: '頭程已發貨',
  已到中转仓: '已到中轉倉',
  跨境运输中: '跨境運輸中',
  退货退款: '退貨退款',
  下单成功: '下單成功',
  '订单总共(': '訂單總共(',
  '项)': '項)',
  留言: '留言',
  '给订单留个言~': '給訂單留個言~',
  提交订单: '提交訂單',
  货款: '貨款',
  运费: '運費',
  '合计：': '合計：',
  合计: '合計',
  '点击“下单”即表示您同意': '點擊“下單”即表示您同意',
  Epaifa的交易条款: 'Epaifa的交易條款',
  结账: '結帳',
  下单: '下單',
  取消成功: '取消成功',
  货品已成功添加到购物车: '貨品已成功添加到購物車',
  单据详情: '單據詳情',
  'COD 服务费': 'COD 服務費',
  总计: '總計',
  实收: '實收',
  订单信息: '訂單信息',
  店铺: '店鋪',
  订单号: '訂單號',
  交易时间: '交易時間',
  经手人: '經手人',
  备注: '備註',
  再次购买: '再次購買',
  单据列表: '單據列表',
  搜索订单: '搜索訂單',
  日期: '日期',
  没有更多了: '沒有更多了',
  '找不到订单哦~': '找不到訂單哦~',
  联系我们: '聯繫我們',
  查看订单: '查看訂單',
  '运输费 {{currencySymbol}} {{slot1}} + COD服务费 {{currencySymbol}} {{slot2}}':
    '運輸費{{currencySymbol}} {{slot1}} + COD服務費{{currencySymbol}} {{slot2}}',
  价格不能小于0: '價格不能小於0',
  '最低价格需<=最高价格': '最低價格需<=最高價格',
  '最高价格需>=最低价格': '最高價格需>=最低價格',
  '整数位不能超过{{integerMaxLength}}位':
    '整數位不能超過{{integerMaxLength}}位',
  '小数位不能超过{{pricePrecision}}位': '小數位不能超過{{pricePrecision}}位',
  最低价格: '最低價格',
  最高价格: '最高價格',
  发货类型: '發貨類型',
  重置: '重置',
  '商品找不到了…': '商品找不到了…',
  联系: '聯繫',
  库存不足无法下单: '庫存不足無法下單',
  '添加成功，在购物车等你': '添加成功，在購物車等你',
  选购: '選購',
  筛选: '篩選',
  '支持货名/属性/条码': '支持貨名/屬性/條碼',
  最近搜索: '最近搜索',
  删除: '刪除',
  当前商品下架已删除: '當前商品下架已刪除',
  '确认删除货品吗？': '確認刪除貨品嗎？',
  全选: '全選',
  '已选：': '已選：',
  是否清空失效货品: '是否清空失效貨品',
  清空成功: '清空成功',
  货品冲突: '貨品衝突',
  '{{infoChangeCount}}件货品档案变更，': '{{infoChangeCount}}件貨品檔案變更，',
  '{{stockCount}}件货品库存不足，': '{{stockCount}}件貨品庫存不足，',
  '{{deleteCount}}件货品下架或删除，': '{{deleteCount}}件貨品下架或刪除，',
  '{{deleteCount}}个货品已下架或库存不足，是否删除？':
    '{{deleteCount}}個商品已下架或庫存不足，是否刪除？',
  是否删除: '是否删除',
  件失效货品: '件失效貨品',
  清空: '清空',
  '购物车还是空的呐～': '購物車還是空的吶～',
  新: '新',
  爆: '爆',
  荐: '薦',
  促: '促',
  '登录已过期，请重新登录': '登錄已過期，請重新登錄',
  '出错了，请检查网络连接或重试': '出錯了，請檢查網絡連接或重試',
  '{{err}}，请检查网络连接或重试': '{{err}}，請檢查網絡連接或重試',
  '{{msg}}，请检查网络连接或重试': '{{msg}}，請檢查網絡連接或重試',
  '出错了~': '出錯了~',
  大额订单说明: '大額訂單說明',
  '订单超过1亿，店长会主动联系您协助完成交易':
    '訂單超過1億，店長會主動聯絡您協助完成交易',
  '超低价格，品质保证': '超低價格，品質保證',
  海外: '海外',
  保税仓库: '保稅倉庫',
  胡志明市: '胡志明市',
  运费信息: '運費資訊',
  邮寄方式: '郵寄方式',
  可用的: '可用的',
  成本: '成本',
  服务费: '服務費',
  任何数量: '任何數量',
  购买: '購買',
  货品属性: '貨品屬性',
  已指派专门的销售代表与您跟进: '已指派專門的銷售代表與您跟進',
  货品总计: '貨品總計',
  项: '項',
  装箱规格: '裝箱規格',
  补货中: '補貨中',
  请选择下单货品: '請選擇下單貨品',
  请填写姓名: '請填寫姓名',
  请填写联系电话: '請填寫聯系電話',
  请填写收货地址: '請填寫收貨地址',
  搜索货品: '搜索貨品',
  请输入数字: '請輸入數字',
  体验一下: '體驗一下',
  请输入正确的手机号码: '請輸入正確的手機號碼',
  请输入正确的邮箱地址: '請輸入正確的郵箱地址',
  多语言: '多語言',
  共: '共',
  种: '種',
  不含税: '不含稅',
  订单金额不在COD范围内: '訂單金額不在COD範圍內',
  更多: '更多',
  获取: '獲取',
  获取邀请码: '獲取一個邀請碼',
  申请邀请码: '請求獲取邀請碼',
  'Zalo扫一扫，加我为好友': '掃碼添加我Zalo好友',
  预计送达: '預計送達',
  请选择物流: '請選擇物流',
  首页模块为空: '首頁模組為空',
  重量: 'Weight',
  体积: '體積',
  探索数以百万计的定制产品满足您的业务需求:
    '探索數以百萬計的客製化產品滿足您的業務需求',
  推荐货品: '推薦貨品',
  手机登录: '手機登錄',
  邮箱登录: '郵箱登錄',
  门店: '店铺',
  仓库分拣中: '倉庫分類中',
  分拣中: '分拣中',
  退货中: '退貨中',
  采购中: '採購中',
  分类: '分類',
  退换货: '退換貨',
  退换单: '退換單',
  上传图片失败: '上傳圖片失敗',
  批发价: '批發價',
  复购率: '複購率',
  月销量: '月銷量',
  没有找到相关商品: '沒有找到相關商品',
  商品总金额: '商品總金額',
  优惠: '優惠',
  '实付：': '實付：',
  退款成功: '退款成功',
  退货成功: '退貨成功',
  退货关闭: '退貨關閉',
  请选择站点: '請選擇站點',
  分享: '分享',
  下载所有图片: '下載所有圖片',
  相册: '相冊',
  正在下载: '正在下載',
  '下载完成，在相册查看': '下載完成，在相冊查看',
  新品2: '新品',
  商品分类: '商品分類',
  暂无商品2: '暫無商品',
  '生成图片中…': '生成圖片中…',
  '新品相册！快来看看！': '新品相冊！快來看看！',
  新品分享: '新品分享',
  扫码查看: '掃碼查看',
  下载图片: '下載圖片',
  分享链接: '分享鏈接',
  好物分享: '好物分享',
  下载: '下載',
  货品详情: '貨品詳情',
  查看新品: '查看新品',
  不含运费: '不含運費',
  '新品分享，点击查看': '新品分享，點擊查看',
}
